import React from 'react';
import { motion } from 'framer-motion';

const FeatureChip = ({ icon, text }) => (
    <div className="flex items-center gap-2 bg-gray-100/80 dark:bg-black/40 backdrop-blur-sm border border-gray-200 dark:border-white/10 rounded-lg px-3 py-2 shadow-sm">
        <span className="text-gray-600 dark:text-white dark:opacity-80">{icon}</span>
        <span className="text-[10px] md:text-xs font-bold text-gray-800 dark:text-white uppercase tracking-wider">{text}</span>
    </div>
);

const InfoBox = ({ title, value, subtext, icon }) => (
    <div className="flex flex-col items-center justify-center p-3 bg-gray-100/80 dark:bg-black/40 backdrop-blur-sm border border-gray-200 dark:border-white/10 rounded-xl hover:border-purple-500/50 transition-colors group shadow-sm">
        <span className="text-gray-500 dark:text-white/60 mb-2 group-hover:text-purple-500 dark:group-hover:text-purple-400 transition-colors">{icon}</span>
        <span className="text-[10px] md:text-[11px] font-bold text-gray-600 dark:text-white/80 uppercase tracking-widest text-center">{title}</span>
        <span className="text-sm md:text-base font-black text-gray-900 dark:text-white uppercase mt-1">{value}</span>
        {subtext && <span className="text-[9px] text-gray-500 dark:text-white/50 uppercase mt-1">{subtext}</span>}
    </div>
);

export default function BgmiHero() {
    return (
        <section className="relative w-full min-h-[420px] md:min-h-[560px] flex items-center justify-center pt-20 overflow-visible bg-white dark:bg-[#0a0a0f]">
            {/* Background Image */}
            <div 
                className="absolute inset-0 z-0 bg-cover bg-top bg-no-repeat"
                style={{ 
                    backgroundImage: `url('/glp_battles_banner.png')`
                }}
            />
            
            {/* Bottom blend: light → white */}
            <div className="absolute inset-0 z-0 dark:hidden"
                style={{
                    background: 'linear-gradient(to bottom, transparent 0%, transparent 50%, rgba(255,255,255,0.6) 75%, white 95%)'
                }}
            />
            {/* Bottom blend: dark → #0a0a0f (matches platform bg) */}
            <div className="absolute inset-0 z-0 hidden dark:block"
                style={{
                    background: 'linear-gradient(to bottom, transparent 0%, transparent 50%, rgba(10,10,15,0.7) 75%, #0a0a0f 95%)'
                }}
            />

            <div className="relative z-10 w-full max-w-[120rem] mx-auto px-4 md:px-8">
                {/* Content removed as requested */}
            </div>
        </section>
    );
}
